import React, { useState, useEffect, useCallback } from 'react'
import './../../App.css';
import './Reports.css';
import axios from '../../api/apiClient';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import { CreateTableForEmployeeSelect } from '../ManageTable';
import { token, domain } from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import jsPDF from "jspdf";
import { format } from 'date-fns';
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
//#region Payslip
function Payslip({ isHideSideMenu }) {
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
  const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
  const [payrollPeriodId, setPayrollPeriodId] = useState("");
  const [payrollPeriodDescription, setPayrollPeriodDescription] = useState("");
  const [company, setCompany] = useState("");
  const [classificationId, setClassificationId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [locationId, setLocationId] = useState(0);

  // const [employeeInfo, setEmployeeInfo] = useState([]);

  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [errorState, setErrorState] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const formatName = (name) => {
    if (name) {
      const nameParts = name.split(", ");
      const formattedName = nameParts.map(part => {
        return part.split('-').map(subPart =>
          subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase()
        ).join('-');
      }).join(", ");

      return formattedName.replace(/\b\w/g, (match) => match.toUpperCase());
    }
    return "";
  };

  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  }

  const downloadPDF = useCallback(async (payrolls) => {
    // Create a new jsPDF instance
    const _doc = new jsPDF();

    const drawLine = (doc, lineY) => {
      const pageWidth = doc.internal.pageSize.getWidth();
      const padding = 10;
      const startX = padding;
      const endX = pageWidth - padding;
      const startY = lineY;
      doc.line(startX, startY, endX, startY);
    };

    const title = (doc, title, titleX, titleY) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setLineWidth(0.5);
      doc.text(title, titleX, titleY);
    }

    const subTitle = (doc, text, x, y, options = {}) => {
      const { fontSize = 12, color = "#000000", thickness = 0.5, lineHeightRatio = 0.1 } = options;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(fontSize);
      doc.setTextColor(color);
      doc.text(text, x, y);
      const textWidth = doc.getTextWidth(text);
      const underlineY = y + (fontSize * lineHeightRatio);
      doc.setLineWidth(thickness);
      doc.line(x, underlineY, x + textWidth, underlineY);
    };

    const infoWithValue = (doc, label, labelX, labelY, value, valueX, valueY, maxWidth, color = "#000000") => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.setTextColor(color); // Allow color customization
      doc.text(label, labelX, labelY);
      doc.setFont("helvetica", "normal");

      // FIXED LINE BELOW: Check if maxWidth exists before splitting
      const splitText = maxWidth ? doc.splitTextToSize(value, maxWidth) : value;

      doc.text(splitText, valueX, valueY);
      doc.setTextColor("#000000"); // Reset to black
    }

    const decimalConverter = (value) => {
      if (!value) {
        return (0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
      return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }

    function formatDate(dateStr) {
      const date = new Date(dateStr);
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      const formattedDate = date.toLocaleDateString("en-US", options);
      return formattedDate;
    }

    payrolls.forEach((payroll, index) => {
      if (index > 0) _doc.addPage();

      const otherCashAdvance = payroll.otherCashAdvances;
      const otherDeductions = payroll.companyLoans;

      const halfPageWidth = _doc.internal.pageSize.getWidth() / 2;
      const secondInfoX = halfPageWidth + 5;

      // Add the image to the PDF
      if (company?.logo) {
        const imgData = `data:image/png;base64,${company.logo}`;
        _doc.addImage(imgData, 'PNG', 65, 5, 70, 30);
      }

      title(_doc, `Payslip for Payroll: ${payrollPeriodDescription} `, 62.5, 30);
      drawLine(_doc, 37.5);

      infoWithValue(_doc, "Employee Name: ", 10, 45, payroll.employeePersonalInformationFullName ? formatName(payroll.employeePersonalInformationFullName) : "", 50, 45);
      infoWithValue(_doc, "Employee Id: ", 10, 50, payroll.employeePersonalInformationEmployeeId ? payroll.employeePersonalInformationEmployeeId : "", 50, 50);
      infoWithValue(_doc, "Position: ", 10, 55, payroll.positionDescription ? payroll.positionDescription : "", 50, 55);
      infoWithValue(_doc, "Hired Date: ", 10, 60, payroll.dateEmployed ? formatDate(payroll.dateEmployed) : "", 50, 60);
      infoWithValue(_doc, "Employer: ", secondInfoX, 45, company.name ? company.name : "", secondInfoX + 50, 45);
      infoWithValue(_doc, "Classification: ", secondInfoX, 50, payroll.classificationDescription ? payroll.classificationDescription : "", secondInfoX + 50, 50);
      infoWithValue(_doc, "Location: ", secondInfoX, 55, payroll.locationDescription ? payroll.locationDescription : "", secondInfoX + 50, 55);
      infoWithValue(_doc, "Pay Type: ", secondInfoX, 60, payroll.payTypeDescription ? payroll.payTypeDescription : "", secondInfoX + 50, 60);
      drawLine(_doc, 65);

      // --- DATA EXTRACTION ---
      const allowance = payroll.totalAllowance ?? 0;
      const benefits = payroll.totalBenefits ?? 0;
      const otherAddition = payroll.totalAddition ?? 0; // Note: Check API casing (TotalAddition vs totalAddition)
      const otherAdjustment = payroll.totalAdjustment ?? 0;
      const totalLeaveEncashment = payroll.totalLeaveEncashment ?? 0;

      const hoursNightDiff = payroll.totalNighDiff;
      const hoursRegularOT = payroll.totalHoursOTRegular;
      const hoursRestdayOT = payroll.totalHoursOTRestday;
      const hoursRestdayRegular = payroll.totalHoursOTRestdayHolidayRegular;
      const hoursRestdaySpecial = payroll.totalHoursOTRestdayHolidaySpecial;
      const hoursRegularHoliday = payroll.totalDaysRegularHolidays;
      const hoursSpecialNonWorkingHoliday = payroll.totalDaysSpecialNonWorkingHolidays;

      const amountNightDiff = payroll.totalNighDiffAmount ?? 0;
      const amountRegularOT = payroll.totalOTRegular ?? 0;
      const amountRestdayOT = payroll.totalOTRestday ?? 0;
      const amountRestdayRegular = payroll.totalOTRestdayHolidayRegular ?? 0;
      const amountRestdaySpecial = payroll.totalOTRestdayHolidaySpecial ?? 0;
      const amountRegularHoliday = payroll.totalRegularHolidays ?? 0;
      const amountSpecialNonWorkingHoliday = payroll.totalSpecialNonWorkingHolidays ?? 0;

      const totalAdditionsOverAll =
        allowance
        + benefits
        + otherAddition
        + otherAdjustment
        + amountNightDiff
        + amountRegularOT
        + amountRestdayOT
        + amountRegularHoliday
        + amountSpecialNonWorkingHoliday
        + amountRestdayRegular
        + amountRestdaySpecial;

      const absentDays = payroll.totalDaysAbsents;
      const absent = payroll.totalAbsents ?? 0;
      const otherDeduction = payroll.totalDeduction ?? 0;

      const hoursTotalLate = payroll.totalHoursLate;
      const hoursTotalLateDeduction = payroll.totalHoursLateDeduction;
      const hoursTotalUndertime = payroll.totalHoursUndertime;

      const amountTotalLate = payroll.totalLate ?? 0;
      const amountTotalLateDeduction = payroll.totalLateDeduction ?? 0;
      const amountTotalUndertime = payroll.totalUndertime ?? 0;
      const amountTax = payroll.totalTax ?? 0;

      // --- <NEW DATA> ---
      const recoveredBalance = payroll.recoveredStatutoryBalance ?? 0; // The deduction amount
      const unpaidBalance = payroll.unpaidStatutoryBalance ?? 0;       // The debt created
      const totalPartialSalaryDeduction = payroll.totalPartialSalaryDeduction ?? 0;       // The debt created
      const totalSalaryAdvance = payroll.totalSalaryAdvance ?? 0; // ADDED THIS
      // --- </NEW DATA> ---

      const totalDeductionOverAll =
        otherDeduction
        + amountTotalLate
        + amountTotalLateDeduction
        + amountTotalUndertime
        + amountTax
        + recoveredBalance
        + totalPartialSalaryDeduction
        + totalSalaryAdvance; // ADDED THIS TO THE SUM

      const balanceSSSLoan = payroll.sssLoanBalance;
      const balanceSSSCalamityLoan = payroll.sssCalamityLoanBalance;
      const balanceSSSEmergencyLoan = payroll.sssEmergencyLoanBalance;
      const balancePagibigLoan = payroll.pagibigLoanBalance;
      const balancePagibigCalamityLoan = payroll.pagibigCalamityLoanBalance;

      const deductionSSSLoan = payroll.totalSSSLoan ?? 0;
      const deductionSSSCalamityLoan = payroll.totalSSSCalamityLoan ?? 0;
      const deductionSSSEmergencyLoan = payroll.totalSSSEmergencyLoan ?? 0;
      const deductionPagibigLoan = payroll.totalPagibigLoan ?? 0;
      const deductionPagibigCalamityLoan = payroll.totalPagibigCalamityLoan ?? 0;

      const totalLoansOverAll =
        deductionSSSLoan +
        deductionSSSCalamityLoan +
        deductionSSSEmergencyLoan +
        deductionPagibigLoan +
        deductionPagibigCalamityLoan

      const sss = payroll.totalSSS ?? 0;
      const philhealth = payroll.totalPagibig ?? 0;
      const pagibig = payroll.totalPhilhealth ?? 0;

      const totalPremiumsOverAll = sss + philhealth + pagibig;

      const dailyRate = payroll.rate ?? 0;
      const daysWorked = payroll.totalDays ?? 0;
      const totalDaysPay = dailyRate * daysWorked;
      const basicPay = payroll.totalBasic ?? 0;
      const grossPay = payroll.totalGrossPay ?? 0;
      const netPay = payroll.totalNetPay ?? 0;



      // --- ADDITIONS SECTION Layout Config---
      const additionSectionHeaderX = 75;
      const additionTitleHeaderX = 10;
      const additionHourHeaderX = 55;
      const additionAmountHeaderX = 80;

      const additionTitleY = 10;
      const additionOtherValueY = 40;
      const additionHoursY = 55;
      const additionAmountY = 80;

      const allowanceX = additionSectionHeaderX + 5;
      const benefitsX = allowanceX + 5;
      const otherAdditionX = benefitsX + 5;
      const otherAdjustmentX = otherAdditionX + 5;
      const nightDifferentialX = otherAdjustmentX + 5;
      const regularOtX = nightDifferentialX + 5;
      const restdayOtX = regularOtX + 5;
      const restdayRegularOtX = restdayOtX + 5;
      const restdaySpecialOtX = restdayRegularOtX + 5;
      const restdayRegularHolidayX = restdaySpecialOtX + 5;
      const specialNonWorkingHolidayX = restdayRegularHolidayX + 5;

      // --- HEADERS ---
      subTitle(_doc, "ADDITIONS", additionTitleHeaderX, additionSectionHeaderX, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Hours", additionHourHeaderX, additionSectionHeaderX, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Amount", additionAmountHeaderX, additionSectionHeaderX, { fontSize: 9, thickness: 0.5 });

      // --- Allowance ---
      infoWithValue(_doc, "Allowance: ", additionTitleY, allowanceX, "", additionOtherValueY, allowanceX);
      infoWithValue(_doc, "", additionTitleY, allowanceX, "-", additionHoursY, allowanceX);
      infoWithValue(_doc, "", additionTitleY, allowanceX, decimalConverter(allowance), additionAmountY, allowanceX);

      // --- Benefits ---
      infoWithValue(_doc, "Benefits: ", additionTitleY, benefitsX, "", additionOtherValueY, benefitsX);
      infoWithValue(_doc, "", additionTitleY, benefitsX, "-", additionHoursY, benefitsX);
      infoWithValue(_doc, "", additionTitleY, benefitsX, decimalConverter(benefits), additionAmountY, benefitsX);

      // --- Other Addition ---
      infoWithValue(_doc, "Other Addition: ", additionTitleY, otherAdditionX, "", additionOtherValueY, otherAdditionX);
      infoWithValue(_doc, "", additionTitleY, otherAdditionX, "-", additionHoursY, otherAdditionX);
      infoWithValue(_doc, "", additionTitleY, otherAdditionX, decimalConverter(otherAddition), additionAmountY, otherAdditionX);

      // --- Benefits ---
      infoWithValue(_doc, "Other Adjustment: ", additionTitleY, otherAdjustmentX, "", additionOtherValueY, otherAdjustmentX);
      infoWithValue(_doc, "", additionTitleY, otherAdjustmentX, "-", additionHoursY, otherAdjustmentX);
      infoWithValue(_doc, "", additionTitleY, otherAdjustmentX, decimalConverter(otherAdjustment), additionAmountY, otherAdjustmentX);

      // --- Night Differential ---
      infoWithValue(_doc, "Night Differential: ", additionTitleY, nightDifferentialX, "", additionOtherValueY, nightDifferentialX);
      infoWithValue(_doc, "", additionTitleY, nightDifferentialX, decimalConverter(hoursNightDiff), additionHoursY, nightDifferentialX);
      infoWithValue(_doc, "", additionTitleY, nightDifferentialX, decimalConverter(amountNightDiff), additionAmountY, nightDifferentialX);
      
      // --- Regular OT ---
      infoWithValue(_doc, "Regular OT: ", additionTitleY, regularOtX, "", additionOtherValueY, regularOtX);
      infoWithValue(_doc, "", additionTitleY, regularOtX, decimalConverter(hoursRegularOT), additionHoursY, regularOtX);
      infoWithValue(_doc, "", additionTitleY, regularOtX, decimalConverter(amountRegularOT), additionAmountY, regularOtX);

      // --- Restday OT ---
      infoWithValue(_doc, "Restday OT: ", additionTitleY, restdayOtX, "", additionOtherValueY, restdayOtX);
      infoWithValue(_doc, "", additionTitleY, restdayOtX, decimalConverter(hoursRestdayOT), additionHoursY, restdayOtX);
      infoWithValue(_doc, "", additionTitleY, restdayOtX, decimalConverter(amountRestdayOT), additionAmountY, restdayOtX);

      // --- Restday Regular ---
      infoWithValue(_doc, "Restday Regular: ", additionTitleY, restdayRegularOtX, "", additionOtherValueY, restdayRegularOtX);
      infoWithValue(_doc, "", additionTitleY, restdayRegularOtX, decimalConverter(hoursRestdayRegular), additionHoursY, restdayRegularOtX);
      infoWithValue(_doc, "", additionTitleY, restdayRegularOtX, decimalConverter(amountRestdayRegular), additionAmountY, restdayRegularOtX);

      // --- Restday Special ---
      infoWithValue(_doc, "Restday Special: ", additionTitleY, restdaySpecialOtX, "", additionOtherValueY, restdaySpecialOtX);
      infoWithValue(_doc, "", additionTitleY, restdaySpecialOtX, decimalConverter(hoursRestdaySpecial), additionHoursY, restdaySpecialOtX);
      infoWithValue(_doc, "", additionTitleY, restdaySpecialOtX, decimalConverter(amountRestdaySpecial), additionAmountY, restdaySpecialOtX);

      // --- Regular Holiday ---
      infoWithValue(_doc, "Regular Holiday: ", additionTitleY, restdayRegularHolidayX, "", additionOtherValueY, restdayRegularHolidayX);
      infoWithValue(_doc, "", additionTitleY, restdayRegularHolidayX, decimalConverter(hoursRegularHoliday), additionHoursY, restdayRegularHolidayX);
      infoWithValue(_doc, "", additionTitleY, restdayRegularHolidayX, decimalConverter(amountRegularHoliday), additionAmountY, restdayRegularHolidayX);

      // --- Special NonWorking Holiday ---
      infoWithValue(_doc, "Special NonWorking Holiday: ", additionTitleY, specialNonWorkingHolidayX, "", additionOtherValueY, specialNonWorkingHolidayX);
      infoWithValue(_doc, "", additionTitleY, specialNonWorkingHolidayX, decimalConverter(hoursSpecialNonWorkingHoliday), additionHoursY, specialNonWorkingHolidayX);
      infoWithValue(_doc, "", additionTitleY, specialNonWorkingHolidayX, decimalConverter(amountSpecialNonWorkingHoliday), additionAmountY, specialNonWorkingHolidayX);

      // --- Total Additions ---
      infoWithValue(_doc, "Total Additions ", additionTitleY, 142.5, "", additionOtherValueY, 142.5);
      infoWithValue(_doc, "", additionTitleY, 142.5, decimalConverter(totalAdditionsOverAll), additionAmountY, 142.5);


      // --- DEDUCTIONS SECTION ---
      const deductionSectionHeaderX = 75;
      const deductionTitleHeaderX = secondInfoX;
      const deductionHourHeaderX = secondInfoX + 40;
      const deductionAmountHeaderX = secondInfoX + 70;

      const absentX = deductionSectionHeaderX + 5;
      const lateX = absentX + 5;
      const lateDeductionX = lateX + 5;
      const undertimeX = lateDeductionX + 5;
      const otherDeductionX = undertimeX + 5;
      const taxX = otherDeductionX + 5;
      const recoveredBalanceX = taxX + 5;
      const partialSalaryDeductionX = recoveredBalanceX + 5;
      const salaryAdvanceX = partialSalaryDeductionX + 5;

      subTitle(_doc, "DEDUCTIONS", deductionTitleHeaderX, deductionSectionHeaderX, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Hours", deductionHourHeaderX, deductionSectionHeaderX, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Amount", deductionAmountHeaderX, deductionSectionHeaderX, { fontSize: 9, thickness: 0.5 });

      // Absent
      infoWithValue(_doc, "Absent: ", deductionTitleHeaderX, absentX, "", deductionHourHeaderX, absentX);
      infoWithValue(_doc, "", deductionTitleHeaderX, absentX, `${decimalConverter(absentDays)} days`, deductionHourHeaderX, absentX);
      infoWithValue(_doc, "", deductionTitleHeaderX, absentX, decimalConverter(), deductionAmountHeaderX, absentX); // Note: Original code passes no value here, seemingly intentional to show 0.00?

      // Late
      infoWithValue(_doc, "Late: ", deductionTitleHeaderX, lateX, "", deductionHourHeaderX, lateX);
      infoWithValue(_doc, "", deductionTitleHeaderX, lateX, decimalConverter(hoursTotalLate), deductionHourHeaderX, lateX);
      infoWithValue(_doc, "", deductionTitleHeaderX, lateX, decimalConverter(amountTotalLate), deductionAmountHeaderX, lateX);

      // Late Deduction
      infoWithValue(_doc, "Late Deduction: ", deductionTitleHeaderX, lateDeductionX, "", deductionHourHeaderX, lateDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, lateDeductionX, decimalConverter(hoursTotalLateDeduction), deductionHourHeaderX, lateDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, lateDeductionX, decimalConverter(amountTotalLateDeduction), deductionAmountHeaderX, lateDeductionX);

      // Undertime
      infoWithValue(_doc, "Undertime: ", deductionTitleHeaderX, undertimeX, "", deductionHourHeaderX, undertimeX);
      infoWithValue(_doc, "", deductionTitleHeaderX, undertimeX, decimalConverter(hoursTotalUndertime), deductionHourHeaderX, undertimeX);
      infoWithValue(_doc, "", deductionTitleHeaderX, undertimeX, decimalConverter(amountTotalUndertime), deductionAmountHeaderX, undertimeX);

      // Other Deduction
      infoWithValue(_doc, "Other Deduction: ", deductionTitleHeaderX, otherDeductionX, "", deductionHourHeaderX, otherDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, otherDeductionX, "-", deductionHourHeaderX, otherDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, otherDeductionX, decimalConverter(otherDeduction), deductionAmountHeaderX, otherDeductionX);

      // Tax
      infoWithValue(_doc, "Tax: ", deductionTitleHeaderX, taxX, "", deductionHourHeaderX, taxX);
      infoWithValue(_doc, "", deductionTitleHeaderX, taxX, "-", deductionHourHeaderX, taxX);
      infoWithValue(_doc, "", deductionTitleHeaderX, taxX, decimalConverter(amountTax), deductionAmountHeaderX, taxX);

      // --- <NEW> RECOVERED BALANCE ---
      // Display the deduction for paying off old debt
      infoWithValue(_doc, "Recovered Balance: ", deductionTitleHeaderX, recoveredBalanceX, "", deductionHourHeaderX, recoveredBalanceX);
      infoWithValue(_doc, "", deductionTitleHeaderX, recoveredBalanceX, "-", deductionHourHeaderX, recoveredBalanceX);
      infoWithValue(_doc, "", deductionTitleHeaderX, recoveredBalanceX, decimalConverter(recoveredBalance), deductionAmountHeaderX, recoveredBalanceX);
      // --- </NEW> ---

      // Partial Salary Deduction — NEW: positioned at y=120 (below Recovered Balance)
      infoWithValue(_doc, "Partial Salary Deduction: ", deductionTitleHeaderX, partialSalaryDeductionX, "", deductionHourHeaderX, partialSalaryDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, partialSalaryDeductionX, "-", deductionHourHeaderX, partialSalaryDeductionX);
      infoWithValue(_doc, "", deductionTitleHeaderX, partialSalaryDeductionX, decimalConverter(totalPartialSalaryDeduction), deductionAmountHeaderX, partialSalaryDeductionX);

      // ADDED: Salary Advance Deduction at y=125
      infoWithValue(_doc, "Total Salary Advance: ", deductionTitleHeaderX, salaryAdvanceX, "", deductionHourHeaderX, salaryAdvanceX);
      infoWithValue(_doc, "", deductionTitleHeaderX, salaryAdvanceX, "-", deductionHourHeaderX, salaryAdvanceX);
      infoWithValue(_doc, "", deductionTitleHeaderX, salaryAdvanceX, decimalConverter(totalSalaryAdvance), deductionAmountHeaderX, salaryAdvanceX);

      // MOVED: Total Deductions moved from 127.5 to 132.5 to avoid overlapping the new line
      infoWithValue(_doc, "Total Deductions: ", deductionTitleHeaderX, 142.5, "", deductionHourHeaderX, 142.5);
      infoWithValue(_doc, "", deductionTitleHeaderX, 142.5, decimalConverter(totalDeductionOverAll), deductionAmountHeaderX, 142.5);

      drawLine(_doc, 147.5);

      // --- PREMIUMS ---
      subTitle(_doc, "PREMIUMS", 10, 155, { fontSize: 9, thickness: 0.5 });
      infoWithValue(_doc, "SSS: ", 10, 160, decimalConverter(sss), 50, 160);
      infoWithValue(_doc, "Philhealth: ", 10, 165, decimalConverter(philhealth), 50, 165);
      infoWithValue(_doc, "Pagibig: ", 10, 170, decimalConverter(pagibig), 50, 170);
      infoWithValue(_doc, "Total Premiums: ", 10, 177.5, decimalConverter(totalPremiumsOverAll), 50, 177.5);

      // --- LOANS ---
      subTitle(_doc, "LOANS", secondInfoX, 155, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Balance", secondInfoX + 40, 155, { fontSize: 9, thickness: 0.5 });
      subTitle(_doc, "Deduction", secondInfoX + 70, 155, { fontSize: 9, thickness: 0.5 });
      infoWithValue(_doc, "SSS Loan: ", secondInfoX, 160, "", secondInfoX + 50, 160);
      infoWithValue(_doc, "", secondInfoX, 160, decimalConverter(balanceSSSLoan), secondInfoX + 40, 160);
      infoWithValue(_doc, "", secondInfoX, 160, decimalConverter(deductionSSSLoan), secondInfoX + 70, 160);
      infoWithValue(_doc, "SSS Calamity Loan: ", secondInfoX, 165, "", secondInfoX + 50, 165);
      infoWithValue(_doc, "", secondInfoX, 165, decimalConverter(balanceSSSCalamityLoan), secondInfoX + 40, 165);
      infoWithValue(_doc, "", secondInfoX, 165, decimalConverter(deductionSSSCalamityLoan), secondInfoX + 70, 165);
      infoWithValue(_doc, "SSS Emgergency Loan: ", secondInfoX, 170, "", secondInfoX + 50, 170);
      infoWithValue(_doc, "", secondInfoX, 170, decimalConverter(balanceSSSEmergencyLoan), secondInfoX + 40, 170);
      infoWithValue(_doc, "", secondInfoX, 170, decimalConverter(deductionSSSEmergencyLoan), secondInfoX + 70, 170);
      infoWithValue(_doc, "Pagibig Loan: ", secondInfoX, 175, "", secondInfoX + 50, 175);
      infoWithValue(_doc, "", secondInfoX, 175, decimalConverter(balancePagibigLoan), secondInfoX + 40, 175);
      infoWithValue(_doc, "", secondInfoX, 175, decimalConverter(deductionPagibigLoan), secondInfoX + 70, 175);
      infoWithValue(_doc, "Pagibig Calamity Loan: ", secondInfoX, 180, "", secondInfoX + 50, 180);
      infoWithValue(_doc, "", secondInfoX, 180, decimalConverter(balancePagibigCalamityLoan), secondInfoX + 40, 180);
      infoWithValue(_doc, "", secondInfoX, 180, decimalConverter(deductionPagibigCalamityLoan), secondInfoX + 70, 180);
      infoWithValue(_doc, "Total Loans: ", secondInfoX, 187.5, "", secondInfoX + 50, 187.5);
      infoWithValue(_doc, "", secondInfoX, 187.5, decimalConverter(totalLoansOverAll), secondInfoX + 70, 187.5);
      drawLine(_doc, 192);

      // --- SUMMARY ---
      subTitle(_doc, "SUMMARY", secondInfoX, 200, { fontSize: 9, thickness: 0.5 });
      infoWithValue(_doc, "Basic Pay: ", secondInfoX, 210, decimalConverter(basicPay), secondInfoX + 40, 210);
      infoWithValue(_doc, "Daily Rate: ", secondInfoX, 215, decimalConverter(dailyRate), secondInfoX + 40, 215);
      infoWithValue(_doc, "Days Worked: ", secondInfoX, 220, decimalConverter(daysWorked), secondInfoX + 40, 220);
      infoWithValue(_doc, "Total Days Pay: ", secondInfoX, 225, decimalConverter(totalDaysPay), secondInfoX + 40, 225);
      infoWithValue(_doc, "Gross Pay: ", secondInfoX, 230, decimalConverter(grossPay), secondInfoX + 40, 230);
      infoWithValue(_doc, "Net Pay: ", secondInfoX, 237.5, decimalConverter(netPay), secondInfoX + 40, 237.5);

      // --- <NEW> UNPAID BALANCE (SHORTAGE) ---
      // If there is a shortage, show it in red below the Net Pay
      // Change null to 50 (or any width that fits the page)
      if (unpaidBalance > 0) {
        infoWithValue(
          _doc,
          "Shortage (Carry Over): ",
          secondInfoX,
          242.5,
          `(${decimalConverter(unpaidBalance)})`,
          secondInfoX + 40,
          242.5,
          50, // <--- Changed from null to 50
          "#ff0000"
        );
      }
      // --- </NEW> ---

      subTitle(_doc, "ADVANCES (Other Loans)", 10, 200, { fontSize: 9, thickness: 0.5 });

      let cashAdvanceY = 205;

      otherCashAdvance.forEach(data => {
        infoWithValue(_doc, `${data.description ? data.description : "No description"}: `, 10, cashAdvanceY, decimalConverter(data.defaultDeduction), 50, cashAdvanceY);

        cashAdvanceY += 5;
      });

      let companyLoanY = cashAdvanceY + 5;

      subTitle(_doc, "ADVANCES (Other Company Loans)", 10, companyLoanY, { fontSize: 9, thickness: 0.5 });

      otherDeductions.forEach(data => {
        infoWithValue(_doc, `${data.description ? data.description : "No description"}: `, 10, companyLoanY + 5, decimalConverter(data.defaultDeduction), 50, companyLoanY + 5);

        companyLoanY += 5;
      });

      drawLine(_doc, companyLoanY + 40);

      title(_doc, `NOTHING FOLLOWS`, secondInfoX - 30, companyLoanY + 55);
    });

    // Save the PDF
    _doc.save(`Payslip_${payrollPeriodDescription}.pdf`);
  }, [company, payrollPeriodDescription]);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/Reports/payslip/payrollperiod/${payrollPeriodId}/classification/${classificationId}/department/${departmentId}/location/${locationId}`;

    try {
      setLoadingRequest(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      if (response.data.length <= 0) {
        setLoadingRequest(false);
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("No record found.");
        return;
      }

      downloadPDF(response.data);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false); // Set loading state to false after data fetching is complete
    }
  }, [downloadPDF, payrollPeriodId, classificationId, departmentId, locationId]);

  const generate = async () => {
    /* if(!employeePersonalInformationId
        && !payrollPeriodId
        && !company
    ){
        setErrorState(true);
        return;
    } */
    if (!payrollPeriodId
      || !company
    ) {
      setErrorState(true);
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Fill up all fields");
      return;
    }

    await fetchData();
    setErrorState(false);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="ReportsInfo shadow-xl">
            <div className="reports-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Reports >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Payslip"}</span>
              </div>
              <h3>Generate Payslip</h3>
            </div>
            <div className="reports-body">
              <div className="info-item-holder row" style={{ alignItems: "center", justifyContent: "normal" }}>
                <div className="info-item3 info-item column" style={{ display: "none" }}>
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Employee</div>
                  <div className="info-item-input">
                    <div className="info-item-holder employee-select row" style={{ flexDirection: "row", justifyContent: "normal" }}>
                      <input
                        readOnly
                        className='employeeInput-select'
                        placeholder="Employee"
                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                      />
                      <button className="select row"
                        onClick={() => setShowEmployeeForm(true)}
                      ><SearchIcon /></button>
                    </div>
                    <span style={{
                      visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px"
                    }}>Please fill up this field
                    </span>
                    {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                  </div>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Payroll Period</div>
                  <div className="info-item-input">
                    <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} setPayrollPeriodDescription={setPayrollPeriodDescription} />
                  </div>
                  <span style={{
                    visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Company</div>
                  <div className="info-item-input">
                    <CompanyTypeSelect company={company} setCompany={setCompany} />
                  </div>
                  <span style={{
                    visibility: !company && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Classification</div>
                  <div className="info-item-input">
                    <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
              <div className="info-item-holder row" style={{ justifyContent: "normal" }}>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Department</div>
                  <div className="info-item-input">
                    <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
                <div className="info-item3 info-item column">
                  <div className="info-item-label" style={{ fontWeight: "normal", fontSize: "14px" }}>Location</div>
                  <div className="info-item-input">
                    <LocationIdSelect locationId={locationId} setLocationId={setLocationId} />
                  </div>
                  <span style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px"
                  }}>Please fill up this field
                  </span>
                </div>
              </div>
            </div>
            <div className="reports-footer">
              <div className="buttons row" style={{ justifyContent: "start" }}>
                <button id="sssReportGenerate"
                  className="generate row"
                  onClick={generate}
                > GENERATE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmployeeSelectForm isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
      // setEmployeeInfo={setEmployeeInfo}
      >
      </EmployeeSelectForm>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loadingRequest ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}
//#endregion Payslip





//#region Filter
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
};
//#endregion





//#region Selects
function EmployeeSelectForm({ isOpen,
  onClose,
  setEmployeeId,
  setEmployee,
  setEmployeeInfo
}) {
  var header = [
    "Id",
    "Name",
  ]
  var accessor = [
    "employeeId",
    "fullName"
  ]

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    setEmployeeInfo(selectedEmployee);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
    const apiUrl = domain + "/api/Employee/";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setEmployees(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name")
        break;
      case 1:
        setSearchPlaceholder("Search by id")
        break;
      default:
        setSearchPlaceholder("Search by name")
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder("",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon)}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleProceed}>
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function PayrollPeriodIdSelect({ payrollPeriodId, setPayrollPeriodId, setPayrollPeriodDescription }) {
  const [isSelected, setIsSelected] = useState(false);
  const [data, setData] = useState([]);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setPayrollPeriodId(event.target.value);
    const selectedPayroll = data.find(item => (item.id).toString() === event.target.value);
    setPayrollPeriodDescription(selectedPayroll.name)
  };

  const fetchData = async () => {
    //const currentYear = new Date().getFullYear();
    //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
    const apiUrl = domain + `/api/PayrollPeriod/active`; // changed

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (payrollPeriodId !== "" && payrollPeriodId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [payrollPeriodId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose payroll period</option>
        {data.map((payrollPeriodId) => (
          SetPayrollPeriodId(payrollPeriodId)
        ))}
      </select>
    </div>
  );
};
function SetPayrollPeriodId(payrollPeriodId) {
  const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
  const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

  return (
    <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
    </option>
  )
}
function CompanyTypeSelect({ company, setCompany }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);

    const selectedCompanyId = event.target.value; // Get the selected company ID
    const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

    if (selectedCompany) {
      setCompany(selectedCompany); // Set the full company object
      setIsSelected(true);
    }
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Company/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (company !== "" && company !== 0 && company !== null && company !== undefined && company.length !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [company]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={company} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose company type</option>
        {data.map((company) => (
          SetCompanyType(company)
        ))}
      </select>
    </div>
  );
};
function SetCompanyType(company) {
  return (
    <option value={company.id}>{
      company.name}
    </option>
  )

}
function ClassificationIdSelect({ classificationId, setClassificationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Classification/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (classificationId !== "" && classificationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [classificationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={classificationId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose classification</option>
        {data.map((classificationId) => (
          SetClassificationId(classificationId)
        ))}
      </select>
    </div>
  );
};
function SetClassificationId(classificationId) {
  return (
    <option value={classificationId.id}>{
      classificationId.description}
    </option>
  )
}
function DepartmentIdSelect({ departmentId, setDepartmentId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setDepartmentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Department/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (departmentId !== "" && departmentId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [departmentId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={departmentId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose department</option>
        {data.map((departmentId) => (
          SetDepartmentId(departmentId)
        ))}
      </select>
    </div>
  );
};
function SetDepartmentId(departmentId) {
  return (
    <option value={departmentId.id}>{
      departmentId.description}
    </option>
  )
}
function LocationIdSelect({ locationId, setLocationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Location/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (locationId !== "" && locationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [locationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={locationId || ""} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose location</option>
        {data.map((locationId) => (
          SetLocationId(locationId)
        ))}
      </select>
    </div>
  );
};
function SetLocationId(locationId) {
  return (
    <option value={locationId.id}>{
      locationId.description}
    </option>
  )

}
//#endregion Selects
export default Payslip
